import {Headers} from '@angular/http';

export const contentHeaders = new Headers();
contentHeaders.append('Accept', 'application/json');
contentHeaders.append('Content-Type', 'application/json');

export function createAuthorizationHeader(headers: Headers) {
    headers.append('Authorization', localStorage.getItem('id_token'));
}


// WEBPACK FOOTER //
// ./src/utils/headers.ts